import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert } from '@cancercentrum/rcc-bootstrap';
/**
 * Shows a bootstrap alert for an AJAX error from one of INCA's API methods.
 */ export const AjaxErrorAlert = (props)=>{
    const { error, ...rest } = props;
    const incaError = error;
    return /*#__PURE__*/ _jsxs(Alert, {
        bsStyle: "danger",
        ...rest,
        children: [
            typeof error !== 'string' && error.message,
            typeof error === 'string' && error,
            incaError.errors && incaError.errors.length > 1 && /*#__PURE__*/ _jsx("ul", {
                children: incaError.errors.map((x, i)=>/*#__PURE__*/ _jsx("li", {
                        children: x.message
                    }, i))
            })
        ]
    });
};
